import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyRoleCreateQuery,
  useLazyRoleViewQuery,
  useRoleAddMutation,
  useRoleEditMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const Role = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;

  const [permissions, setPermissions] = useState([]);
  const [permissonList, setPermissionList] = useState([]);
  const [roles, setRole] = useState("");
  const [rolesErr, setRoleErr] = useState(false);
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [roleCreateApi] = useLazyRoleCreateQuery();
  const [roleAddApi] = useRoleAddMutation();
  const [roleEditApi] = useRoleEditMutation();
  const [roleViewApi] = useLazyRoleViewQuery();

  const getCreateRole = () => {
    dispatch(saveLoader(true));
    roleCreateApi()
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setPermissionList(res?.modules);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCreateRole();
  }, []);

  const rolefunction = (id) => {
    let roleId = [...permissions];

    if (roleId.includes(id)) {
      let ids = roleId.indexOf(id);
      roleId.splice(ids, 1);
      setPermissions(roleId);
    } else {
      roleId.push(id);
      setPermissions(roleId);
    }
  };

  const submitHandler = () => {
    if (roles?.length == 0) {
      setRoleErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("role", roles);

      permissions?.map((item, ind) => {
        formdata.append(`permissions[${ind}]`, item);
      });

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        formdata.append("_method", "PUT");
        roleEditApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/roles");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err");
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        roleAddApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status === "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/roles");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.error("Error", err);
          });
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    roleViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          let temp = [];
          res?.permissions?.map((item, ind) => {
            temp.push(item);
          });
          setPermissions(temp);
          if (res?.role?.id) {
            setRole(res?.role?.role);
          }
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={types == "edit" ? "edit-role" : "add-role"} />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-4">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Role Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setRole(e.target.value)}
                  value={roles}
                />
              </div>
              {roles?.length == 0 && rolesErr && (
                <p className="err">Enter Role</p>
              )}
            </div>
          </Row>
          <Row>
            <div className="col-md-12 mt-4">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Permission:
                </label>
              </div>
            </div>
            <div className="p-3 mx-4">
              <div className="d-flex flex-wrap">
                {permissonList?.map((item, id) => {
                  return (
                    <div className="col-md-4 mt-3 ps-1" key={id}>
                      <p className="f3 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18">
                        {item?.module_type}
                      </p>

                      <div className="d-flex ac-js gap-2">
                        <div>
                          {item?.permissions?.map((permission, index) => {
                            return (
                              <div
                                className="d-flex ac-js gap-2 mb-2"
                                key={index}
                              >
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="flexSwitchCheckChecked"
                                    checked={permissions?.includes(
                                      permission?.id
                                    )}
                                    onClick={() => rolefunction(permission?.id)}
                                  />
                                  <label
                                    className="form-check-label f1 fs-xs-10  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0"
                                    for="flexSwitchCheckChecked"
                                  >
                                    {permission?.code}
                                  </label>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="mb-5 mt-2">
              {permissions?.length > 0 && (
                <button
                  className={`submit-btn f2 mx-4 ${btn ? "opacity-50" : ""}`}
                  onClick={() => submitHandler()}
                  disabled={btn}
                >
                  Submit
                </button>
              )}
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Role;
